import React from 'react'

export default function Shell() {
  return (
    <div className='w-1/6'></div>
  )
}
